import React, { useCallback, useRef } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Col, Container, Row } from 'react-bootstrap';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
import Input from '../../../components/Input';
import Paginacao from '../../../components/Paginacao';
import SelectSync from '../../../components/SelectSync';
import { GrupoLinha, GrupoLista } from '../styles';
import getValidationErrors from '../../../utils/getValidationErrors';
import { IGrupos } from '..';

// import { Container } from './styles';
export interface IPaginacao {
  termoBusca: IFormBusca;
  limite: number;
  pagina: number;
}

export interface IFormBusca {
  nome?: string;
  situacao?: string;
}

type Props = {
  paginacao: IPaginacao | undefined;
  grupos: IGrupos[] | undefined;
  totalRegistros: number | undefined;
  setPaginacao(dados: IPaginacao | undefined): void;
  setGrupos(dados: IGrupos[] | undefined): void;
  handleDelete(gexCodigo: number): void;
  handleProximaPagina(page: number): void;
  setCodigo(codigo: number | undefined): void;
  setNovo(valor: boolean): void;
};
const Listagem: React.FC<Props> = ({
  paginacao,
  grupos,
  totalRegistros,
  setPaginacao,
  setGrupos,
  handleDelete,
  handleProximaPagina,
  setCodigo,
  setNovo,
}) => {
  const formRefBusca = useRef<FormHandles>(null);

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      try {
        formRefBusca.current?.setErrors({});
        const schema = Yup.object().shape({
          nome: Yup.string(),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        setGrupos(undefined);

        const { nome, situacao } = dados;

        setPaginacao({
          termoBusca: {
            nome,
            situacao,
          },
          pagina: 1,
          limite: 20,
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        }
      }
    },
    [setGrupos, setPaginacao],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <Container fluid className="mt-2">
      <div className="mb-2 p-2 bg-white border rounded">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <h6 id="topoBusca">Pesquisa Grupo de Exames</h6>
          {/* <Button
          type="button"
          variant="outline-primary"
          size="sm"
          onClick={() => history.push('/agendas')}
        >
          Voltar para agendas
        </Button> */}
        </div>

        <Form
          ref={formRefBusca}
          initialData={paginacao?.termoBusca}
          onSubmit={handleSubmitBusca}
        >
          <Row noGutters>
            <Col sm={12} md={5} lg={5} className="pr-1">
              <Input name="nome" label="Nome" maxLength={100} minLength={3} />
            </Col>

            <Col sm={12} md={3} lg={3} className="pr-1">
              <SelectSync
                name="situacao"
                label="Status"
                handleSelectChange={handleOnChangeVazio}
                isClearable
                options={[
                  { label: 'Ativo', value: 'true' },
                  { label: 'Desativado', value: 'false' },
                ]}
              />
            </Col>
            <Col sm={12} md={2} lg={2} className="pr-1">
              <b style={{ marginBottom: '4px', display: 'block' }} />
              <Button
                type="submit"
                size="sm"
                className="mt-3"
                variant="primary"
              >
                BUSCAR
              </Button>
            </Col>
            <Col sm={12} md={2} lg={2} className="pr-1">
              <b style={{ marginBottom: '4px', display: 'block' }} />
              <Button
                type="button"
                size="sm"
                className="mt-3"
                variant="success"
                onClick={() => {
                  setNovo(true);
                  setCodigo(undefined);
                }}
              >
                <FaPlus /> NOVO GRUPO
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="bg-white border p-2 rounded">
        {grupos ? (
          <>
            <Row noGutters className="bg-light py-2 border-top border-bottom">
              <Col md={3}>
                <b>Nome</b>
              </Col>
              <Col md={3}>
                <b>Perfil</b>
              </Col>
              <Col md={2} lg={2}>
                <b>Status</b>
              </Col>
              <Col md={2} lg={2}>
                <b>Selecionado</b>
              </Col>
            </Row>
            {grupos.map(grp => (
              <GrupoLinha
                className="row no-gutters"
                key={`grp-${grp.GexCodigo}`}
                data-id={grp.GexCodigo}
              >
                <div className="col-md-3 ">
                  <GrupoLista>{grp.GexNome}</GrupoLista>
                </div>
                <div className="col-md-3 ">
                  <GrupoLista>{grp.perfil.PerNome}</GrupoLista>
                </div>
                <div className="col-md-2 col-lg-2">
                  <GrupoLista>{grp.ativoFormatado}</GrupoLista>
                </div>
                <div className="col-md-2 col-lg-2">
                  <GrupoLista>{grp.selecionadoFormatado}</GrupoLista>
                </div>

                <div className="col-md-2 col-lg-1">
                  <GrupoLista>
                    <Button
                      type="button"
                      variant="outline-success"
                      size="sm"
                      data-id={grp.GexCodigo}
                      title={`Cod: ${grp.GexCodigo?.toString()}`}
                      onClick={() => setCodigo(grp.GexCodigo)}
                    >
                      Editar
                    </Button>
                  </GrupoLista>
                </div>
                <div className="col-md-2 col-lg-1">
                  <GrupoLista>
                    <Button
                      type="button"
                      variant="outline-danger"
                      size="sm"
                      title={`Cod: ${grp.GexCodigo?.toString()}`}
                      data-id={grp.GexCodigo}
                      onClick={() => {
                        grp.GexCodigo && handleDelete(grp.GexCodigo);
                      }}
                    >
                      <FaTrashAlt size={18} />
                    </Button>
                  </GrupoLista>
                </div>
              </GrupoLinha>
            ))}
          </>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '250px' }}
          >
            <h5>Pesquise pelo nome do grupo ou pelo status.</h5>
          </div>
        )}

        <Paginacao
          limitePagina={paginacao?.limite || 20}
          paginasVizinhas={2}
          totalRegistros={totalRegistros}
          paginaInicio={paginacao?.pagina}
          handleProximaPagina={handleProximaPagina}
        />
      </div>
    </Container>
  );
};

export default Listagem;
